import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMultibaggerListServiceApi, MultibaggerAllocationApi } from "../../../redux/portfolio/portfolio";
import moment from "moment";
import { APP_URL } from "../../../config/constants.config";
import { generateSymbolColors } from "../../../components/chartColor";
import Chart from 'react-apexcharts'
import Layout from "../../layout/Layout";
import MultibaggerModal from "../interface/multibaggerModel";
import { setuserDetail } from "../../../redux/auth/auth";
import toast from "react-hot-toast";
import { useDocumentTitle } from "../../../utils/Common";
import { useTheme } from "../../../utils/theme";
import { LiveCallsService } from "../../liveCalls/LiveCalls.service";
import { Eye, EyeOff } from "lucide-react";

const numberToWords = (num) => {
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
    'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const convert = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + convert(n % 100) : "");
    if (n < 100000) return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
    if (n < 10000000) return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
    return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + convert(n % 10000000) : "");
  };

  if (!num || isNaN(num)) return '';
  return convert(Number(num)) + " Only";
};
export default function Multibagger() {
  const { theme } = useTheme();
  const userDetail = useSelector((state) => state.auth.userDetail);
  const portFolioList = useSelector((state) => state.portfolio.portFolioList);
  const userMultibaggerList = useSelector(
    (state) => state.portfolio.userMultibaggerData
  );
  const symbols = userMultibaggerList?.dataList?.map(item => item.symbol) || [];
  const symbolColors = generateSymbolColors(symbols);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Porfolio");
  const [AlertData, setAlertData] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [stocks, setStocks] = useState(portFolioList);
  const modalRef = useRef(null);
  const shares = 10;
  const price = 256;
  const [selectedStockId, setSelectedStockId] = useState(null);
  const [isChartLabelBlurred, setIsChartLabelBlurred] = useState(false);
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "right",
        fontSize: "12px",
        width: 150,
        itemMargin: {
          vertical: 6,
        },
        formatter: (seriesName) =>
          seriesName.length > 10 ? `${seriesName.slice(0, 10)}...` : seriesName,
      },
      chart: {
        type: 'pie'
      },
      plotOptions: {
        pie: {
          // Offset the whole pie chart
          offsetX: 0,
          offsetY: 20,
          donut: {
            size: '70%', // Adjust donut size for inner space
            labels: {
              show: true, // Show inner labels
              name: {
                show: true,
                fontSize: '13px',
                offsetY: -6,

                // ... other label styles
              },
              value: {
                show: true,
                fontSize: '12px',
                offsetY: 6,
                formatter: (val) =>
                  Number(val).toLocaleString("en-IN", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  }),
                // ... other label styles
              }
            }
          },

          dataLabels: {
            offset: 10,

            // Distance of data labels from pie edge
            // ... other dataLabel settings
          }

        }
      }
    },
  });

  const handleSave = () => {
    setShowModal(false);
    alert("hello");
  };
  useDocumentTitle("Multibaggers")
  useEffect(() => {
    const labelColor = theme === "dark" ? "#f8fafc" : "#111827";
    const legendColor = theme === "dark" ? "#e5e7eb" : "#374151";

    setChartData(prev => ({
      ...prev,
      options: {
        ...prev.options,
        legend: {
          ...prev.options.legend,
          labels: {
            ...prev.options.legend?.labels,
            colors: legendColor,
          },
        },
        plotOptions: {
          ...prev.options.plotOptions,
          pie: {
            ...prev.options.plotOptions?.pie,
            donut: {
              ...prev.options.plotOptions?.pie?.donut,
              labels: {
                ...prev.options.plotOptions?.pie?.donut?.labels,
                name: {
                  ...prev.options.plotOptions?.pie?.donut?.labels?.name,
                  color: labelColor,
                },
                value: {
                  ...prev.options.plotOptions?.pie?.donut?.labels?.value,
                  color: labelColor,
                },
                total: {
                  ...prev.options.plotOptions?.pie?.donut?.labels?.total,
                  color: labelColor,
                },
              },
            },
          },
        },
      },
    }));
  }, [theme]);

  useEffect(() => {
    const list = userMultibaggerList?.dataList;
    if (!Array.isArray(list) || list.length === 0) return;
    const labels = list.map(item => item.symbol);
    const series = list.map(item => Number(item.currentVal));
    const colors = labels.map(symbol => symbolColors[symbol]);

    setChartData(prev => ({
      ...prev,
      series,
      options: {
        ...prev.options,
        labels,
        colors, // ✅ FIXED
      },
    }));
  }, [userMultibaggerList?.dataList]);
  useEffect(() => {
    // document.oncontextmenu = function () {
    //   return false;
    // };
    // const handleClickOutside = (event) => {
    //   if (modalRef.current && !modalRef.current.contains(event.target)) {
    //     setShowModal(false);
    //   }
    // };

    // if (showModal) {
    //   document.addEventListener("mousedown", handleClickOutside);
    // } else {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // }

    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, [showModal]);
  useEffect(async () => {
    dispatch(getMultibaggerListServiceApi(userDetail?.id));
    const res = await LiveCallsService(localStorage.getItem("pacId"))
    setAlertData(res?.data?.data)
  }, []);

  const formatNumber = (num) => {
    return Number(num || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const exitPriceCount = useMemo(() => {
    return userMultibaggerList?.dataList
      ?.filter(item => item.exitPrice)
      ?.reduce((total, stock) => total + (stock.overallPLVal || 0), 0);
  }, [userMultibaggerList?.dataList]);

  const { openCount, closedCount, totalCount } = useMemo(() => {
    return (userMultibaggerList?.dataList || []).reduce(
      (acc, item) => {
        if (item.exitPrice) {
          acc.closedCount += 1;
        } else {
          acc.openCount += 1;
        }
        acc.totalCount += 1;
        return acc;
      },
      { openCount: 0, closedCount: 0, totalCount: 0 }
    );
  }, [userMultibaggerList?.dataList]);
  const [amounts, setAmounts] = useState({
    portfolioAmt: "",
  });

  const [validationErrors, setValidationErrors] = useState({});

  const handleAmountChange = (key) => (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Only digits
    const formattedValue = new Intl.NumberFormat("en-IN").format(Number(rawValue));

    setAmounts((prev) => ({
      ...prev,
      [key]: formattedValue,
    }));

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [key]: "",
    }));
  };
  const validation = () => {
    let errors = {};
    const wealth = Number(amounts.portfolioAmt.replace(/,/g, ''));
    if (!wealth || wealth <= 0 || wealth < 20000) {
      errors.portfolioAmt = "Minimum amount is ₹20,000";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleMultibaggerAllocation = async () => {
    if (!validation()) return;
    const payload = {
      multibaggerAllocation: Number(amounts.portfolioAmt.replace(/,/g, '')),
      wealthInvestmentAmt: 0
      // userId: userId
    };
    const response = await dispatch(MultibaggerAllocationApi(payload));
    if (MultibaggerAllocationApi.fulfilled.match(response)) {
      toast.success(response?.payload?.message);
      dispatch(setuserDetail(payload))
      // window.location.reload();
    }
  };

  return (
    <Layout>
      <div className="text-body-emphasis">
        {/* <Header /> */}
        {userDetail.multibaggerAllocation > 0 ?
          <>
            {/* {userMultibaggerList?.dataList.length > 0 ?  */}
            <section id="user-portfolio" className="py-4">
              <div className="container">
                <div className="row justify-content-center justify-content-md-between g-3 align-items-center mb-5">
                  <div class="col-md-12">
                    <a
                      href="/dashboard"
                      class="text-decoration-none text-body-emphasis fs-5"
                    >
                      <i class="fa fa-arrow-left"></i>
                    </a>
                  </div>
                  {/* <div className="col-12 mb-3">
                <div className='d-flex align-items-baseline'>
                  <h4 className="mb-0 fw-bold">Multibaggers</h4>
                </div>
                <p className='text-muted'>EP Multibaggers <small className="fw-normal text-muted ">({userMultibaggerList?.dataList?.length || 0} Stocks)</small></p>
              </div> */}
                  <div className="col-md-8">
                    <div className="row g-3 align-items-center summary-stats-row">
                      <div class="col-md-12">
                        <div class="d-flex justify-content-start align-items-start gap-3">
                          <div>
                            <h4 class="mb-1 fw-bold">Multibaggers</h4>
                            <small class="fw-normal text-muted">
                              <small className="fw-normal text-muted ">({userMultibaggerList?.dataList?.length || 0} Stocks)</small>
                            </small>
                          </div>
                          <button
                            type="button"
                            className={`btn btn-outline-dark btn-sm portfolio-eye-toggle ${theme === "dark" ? "text-light border-light" : ""}`}
                            aria-label={
                              isChartLabelBlurred
                                ? "Show chart labels"
                                : "Blur chart labels"
                            }
                            title={
                              isChartLabelBlurred
                                ? "Show chart labels"
                                : "Blur chart labels"
                            }
                            onClick={() =>
                              setIsChartLabelBlurred((prev) => !prev)
                            }
                          >
                            {isChartLabelBlurred ? (
                              <EyeOff size={16} strokeWidth={2} />
                            ) : (
                              <Eye size={16} strokeWidth={2} />
                            )}
                          </button>
                          {/* <button
                          class="btn btn-outline-dark btn-sm"
                          onClick={() => {
                            navigate("/my-account");
                            localStorage.removeItem("selectedPortfolio");
                          }}
                        >
                          <i class="fa fa-plus-circle" aria-hidden="true"></i>{" "}
                          <span class="mb-1">
                            <small>Add Funds</small>
                          </span>
                        </button> */}
                        </div>
                      </div>
                      <div className="col-md-3 col-6 summary-metric">
                        <small className="text-muted d-block">Invested</small>
                        <h4 className="mb-0">
                          {userMultibaggerList?.meta?.invested?.toLocaleString("en-IN")}
                        </h4>
                      </div>
                      <div className="col-md-3 col-6 summary-metric">
                        <small className="text-muted d-block">
                          Current Value
                        </small>
                        <h4 className="mb-0">
                          {userMultibaggerList?.meta?.currentValue?.toLocaleString("en-IN")}
                        </h4>
                      </div>
                      <div className="col-md-3 col-6 summary-metric">
                        <small className="text-muted d-block">Current P&L</small>
                        <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                          <h4
                            className={`summary-metric-amount ${userMultibaggerList?.meta?.overallPLAmt >= 0 ? "text-success" : "text-danger"} mb-0`}
                          >
                            {userMultibaggerList?.meta?.overallPLAmt >= 0 ? "" : "-"}
                            {/* {userMultibaggerList?.meta?.overallPnl?.toFixed(2)} */}
                            {Math.abs(
                              userMultibaggerList?.meta?.overallPLAmt || 0,
                            ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h4>
                          <small
                            className={`summary-metric-percent ${userMultibaggerList?.meta?.overallPLPer >= 0 ? "text-success" : "text-danger"}`}
                          >
                            ({userMultibaggerList?.meta?.overallPLPer || 0}%)
                          </small>
                        </div>
                      </div>
                      <div className="col-md-3 col-6 summary-metric">
                        <small className="text-muted d-block">Day's P&L</small>
                        <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                          <h4
                            className={`${userMultibaggerList?.meta?.todayGainAmt >= 0 ? "text-success" : "text-danger"} mb-0`}
                          >
                            {userMultibaggerList?.meta?.todayGainAmt >= 0 ? "" : "-"}
                            {/* {userMultibaggerList?.meta?.todayGainAmt?.toFixed(2)} */}
                            {Math.abs(
                              userMultibaggerList?.meta?.todayGainAmt || 0,
                            ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </h4>
                          <small
                            className={`${userMultibaggerList?.meta?.todayGainAmt >= 0 ? "text-success" : "text-danger"}`}
                          >
                            ({userMultibaggerList?.meta?.todayGainPer || 0}%)
                          </small>
                        </div>
                      </div>
                      <div className="col-md-3 col-6 summary-metric">
                        <small className="text-muted d-block">Booked P&L</small>
                        <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                          <h4
                            className={`${exitPriceCount > 0
                              ? "text-success"
                              : exitPriceCount < 0
                                ? "text-danger"
                                : "text-dark"
                              }`}

                          >
                            ₹{formatNumber(exitPriceCount)}{" "}
                          </h4>
                          {/* <small className={`${userMultibaggerList?.meta?.dayPnlAmt >= 0 ? "text-success" : "text-danger"}`}>({userMultibaggerList?.meta?.todayNetChange || 0}%)</small> */}
                        </div>
                      </div>
                      <div className="col-md-3 col-6 summary-metric">
                        <small className="text-muted d-block">Overall P&L</small>
                        <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                          <h4
                            className={`${userMultibaggerList?.meta?.overallPLAmt + exitPriceCount > 0
                              ? "text-success"
                              : "text-danger"
                              }`}
                          >
                            ₹{formatNumber(userMultibaggerList?.meta?.overallPLAmt + exitPriceCount)}{" "}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className={
                        isChartLabelBlurred
                          ? "portfolio-chart-labels-blurred"
                          : ""
                      }
                    >
                      <Chart
                        options={chartData.options}
                        series={chartData.series}
                        type="donut"
                        height={260}
                        width="100%"
                      />
                    </div>
                  </div>
                  {/* </div> */}

                  {/* Table */}
                  {/* <h5
                className={`fw-semibold `}
              >
                <small >
                  Open
                </small>
              </h5> */}
                  {AlertData?.map((stock, index) => (
                    <>
                      {stock.type == "" && (
                        <div className="alert alert-primary d-inline-block">
                          <small className="mb-0">
                            {/* <i className="fa fa-triangle-exclamation"></i>{" "} */}
                            {stock.serMsg}
                          </small>
                        </div>
                      )}
                      {stock.type == "buy" && (
                        <div className="alert alert-primary d-inline-block me-2">
                          <small className="mb-0">
                            <i className="fa fa-triangle-exclamation"></i>{" "}
                            {stock.serMsg || stock.msg}
                          </small>
                        </div>
                      )}
                      {stock.type == "sell" && (
                        <div className="alert alert-warning d-inline-block">
                          <small className="mb-0">
                            <i className="fa fa-triangle-exclamation"></i>{" "}
                            {stock.serMsg || stock.msg}
                          </small>
                        </div>
                      )}
                      {stock.type == "allocateFund" && (
                        <div
                          class="d-inline-block alert alert-success uni-cursor-pointer"
                          onClick={() => {
                            // navigate("/fund-allocation");
                            localStorage.setItem("allocationId", stock.id);
                          }}
                        >
                          {/* <div class="row g-3 justify-content-center align-items-center">
                            <div class="col-md-7 col-12">*/}
                          {/* <div class="d-flex gap-3 justify-content-between align-items-center"> */}
                          <small class="mb-0">
                            <i
                              class="fa fa-triangle-exclamation"
                              aria-hidden="true"
                            ></i>{" "}
                            {stock.msg} , Amt : {stock?.amt}
                          </small>
                          <i class="fa-solid fa-arrow-right ms-2 "></i>
                          {/* </div> */}
                          {/* </div>
                            <div class="col-md-5"> */}
                          {/* <div class="d-flex gap-2 justify-content-md-end justify-content-center"> */}
                          {/* <p class="mb-0 pt-1">Amt : {stock?.amt}</p> */}
                          {/* <a href="./fund-allocation.php" class="btn btn-sm btn-dark">Allocate Now</a> */}
                          {/* </div>
                            </div> */}
                          {/* </div> */}
                        </div>
                      )}
                    </>
                  ))}
                  <div class="d-flex align-items-baseline">
                    <h5 class="mb-1 fw-bold">Open Recommendations</h5>
                    <small class="text-muted ms-2">
                      ({openCount} {openCount > 1 ? "Stocks" : "Stock"})
                    </small>
                  </div>
                  {userMultibaggerList?.dataList.length > 0 ?
                    <div>
                      <div
                        className={`p-3 rounded-3 d-none d-md-block ${theme === "dark" ? "text-light" : "bg-white text-dark"
                          }`}
                        style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                      >
                        <div className="row g-3 small multibagger-table-row">
                          {/* <div className="p-3 rounded-3 bg-dark text-light d-none d-md-block">
                        <div className="row g-3 small"> */}
                          <div className="col-md-2">Scrip</div>
                          <div className="col-md-2 text-end"></div>
                          <div className="col-md-1 text-end">Invested</div>
                          <div className="col-md-1 text-end">Current Val.</div>
                          <div className="col-md-1 text-end">Avg. Price</div>
                          <div className="col-md-1 text-end">CMP</div>
                          <div className="col-md-2 text-end">1 Day P&L</div>
                          <div className="col-md-2 text-end">Total P&L</div>

                        </div>
                      </div>

                      {userMultibaggerList?.dataList?.length > 0 && userMultibaggerList?.dataList?.bookedAt == null ? (
                        userMultibaggerList.dataList.filter((item) => item.bookedAt == null).map((stock, idx) => (
                          <div
                            key={idx}
                            className={`p-3 rounded-3 my-2 ${theme === "dark" ? "text-light" : "bg-light text-dark"
                              }`}
                            style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                          >
                            <div className="row g-2 align-items-center multibagger-table-row">

                              {/* Scrip */}
                              <div className="col-md-2 col-6">
                                <div className="">
                                  <i
                                    className="fa fa-circle fa-2xs me-2"
                                    style={{
                                      color: symbolColors[stock.symbol],
                                      // fontSize: "10px",
                                    }}
                                  ></i>

                                  <span
                                    className={
                                      isChartLabelBlurred
                                        ? "portfolio-sensitive-label-blurred"
                                        : ""
                                    }
                                  >
                                    {stock.symbol}
                                  </span>

                                  <br class="" />
                                  <small className="ms-2">
                                    <small className="text-muted ">
                                      <i className="fas fa-briefcase"></i>{" "} {stock.qty?.toLocaleString("en-IN")} Shares
                                    </small>
                                  </small>
                                </div>
                              </div>


                              {/* <div className="col-md-2 col-6">
                                <div className="text-end" style={{ cursor: "pointer" }}>
                                  <i
                                    className="fa fa-file text-primary me-2"
                                    style={{ fontSize: "12px" }}
                                  ></i>

                                  <span
                                    className="text-primary uni-cursor-pointer small"
                                    onClick={() => setSelectedStockId(stock.id)}
                                  >
                                    View Report
                                  </span>
                                </div>
                              </div> */}
                              <div className="col-md-2 col-6">
                                <div className="text-end" style={{ cursor: "pointer" }}>
                                  <i
                                    className="fa fa-file text-primary me-2"
                                    style={{ fontSize: "12px" }}
                                  ></i>

                                  <span
                                    className="text-primary uni-cursor-pointer small"
                                    tabIndex={0} // makes it focusable
                                    role="button" // improves accessibility
                                    onClick={() => setSelectedStockId(stock.id)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" || e.key === " ") {
                                        setSelectedStockId(stock.id);
                                      }
                                    }}
                                  >
                                    View Report
                                  </span>
                                </div>
                              </div>

                              <div className="col-md-2 col-6 d-md-none">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small className="d-block d-md-none text-muted">
                                      Invested
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.currentVal >= stock.invested
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.invested.toFixed(2)}
                                  </span>
                                  <small class="d-block mt-2 mt-md-0">
                                    <small class="d-block d-md-none text-muted">
                                      Current Val.
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.currentVal >= stock.invested
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.currentVal.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-1 d-none d-md-block">
                                <div class="text-end">
                                  <span
                                    className={
                                      stock.currentVal >= stock.invested
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.invested.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-1 d-none d-md-block">
                                <div class="text-end">
                                  <span
                                    className={
                                      stock.currentVal >= stock.invested
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.currentVal.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                              {/* Recom Date */}
                              {/* <div className="col-md-1 col-6 text-md-end">
                        <small className="d-md-none text-muted">Recom Date</small>
                        {moment(stock.recomandedDate).format("D MMM YYYY")}
                      </div> */}

                              {/* Avg & CMP */}
                              <div className="col-md-2 col-6 d-md-none">
                                <div class="text-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      Avg. Price{" "}
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.ltp >= stock.recomPrice
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.recomPrice.toFixed(2)}
                                  </span>
                                  <small class="d-block mt-2 mt-md-0">
                                    <small class="d-block d-md-none text-muted">
                                      CMP
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.ltp >= stock.recomPrice
                                        ? "text-success d-block"
                                        : "text-danger d-block"
                                    }
                                  >
                                    {stock.ltp.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-1 d-none d-md-block">
                                <div class="text-end">
                                  <span
                                    className={
                                      stock.ltp >= stock.recomPrice
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.recomPrice.toFixed(2)}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-1 d-none d-md-block">
                                <div class="text-end">
                                  <span
                                    className={
                                      stock.ltp >= stock.recomPrice
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.ltp.toFixed(2)}
                                  </span>
                                </div>
                              </div>

                              {/* Day P&L */}
                              <div className="col-md-2 col-6">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      1 Day P&L
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.todayPLVal >= 0
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.todayPLVal.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                    })}
                                    <br />
                                    <small>
                                      ({stock.todayPLPer.toFixed(2)}%)
                                      <i
                                        className={`fa fa-caret-${stock.todayPLPer >= 0 ? "up" : "down"}`}
                                      ></i>
                                    </small>
                                  </span>
                                </div>
                              </div>

                              {/* Total P&L */}
                              <div className="col-md-2 col-6">
                                <div class="text-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      Total P&amp;L
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.overallPLVal >= 0
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.overallPLVal.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                    })}
                                    <br />
                                    <small>
                                      ({stock.overallPLPer.toFixed(2)}%)
                                      <i
                                        className={`fa fa-caret-${stock.overallPLPer >= 0 ? "up" : "down"}`}
                                      ></i>
                                    </small>
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Modal */}
                            {selectedStockId === stock.id && (
                              <div className="modal fade show d-block" tabIndex="-1">
                                <div className="modal-dialog modal-xl modal-dialog-centered">
                                  <div
                                    className="modal-content"
                                    style={{
                                      backgroundColor: theme === "dark" ? "#000" : "#fff",
                                      color: theme === "dark" ? "#fff" : "#000",
                                    }}
                                  >
                                    <div className="modal-header">
                                      <h5 className="modal-title">{stock.symbol} Report</h5>

                                      <button
                                        className={`btn-close ${theme === "dark" ? "btn-close-white" : ""}`}
                                        onClick={() => setSelectedStockId(null)}
                                      ></button>
                                    </div>

                                    <div
                                      className="modal-body"
                                      style={{
                                        height: "80vh",
                                        backgroundColor: theme === "dark" ? "#000" : "#fff",
                                      }}
                                    >
                                      <iframe
                                        src={`${stock.multibaggerReportPath}#toolbar=0`}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          border: 0,
                                          backgroundColor: theme === "dark" ? "#000" : "#fff",
                                        }}
                                        title={stock.symbol}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              // <div className="modal fade show d-block" tabIndex="-1">
                              //   <div className="modal-dialog modal-xl modal-dialog-centered">
                              //     <div className="modal-content">
                              //       <div className="modal-header">
                              //         <h5 className="modal-title">{stock.symbol} Report</h5>
                              //         <button
                              //           className="btn-close"
                              //           onClick={() => setSelectedStockId(null)}
                              //         ></button>
                              //       </div>
                              //       <div className="modal-body" style={{ height: "80vh" }}>
                              //         <iframe
                              //           src={`${stock.multibaggerReportPath}#toolbar=0`}
                              //           style={{ width: "100%", height: "100%", border: 0 }}
                              //           title={stock.symbol}
                              //         />
                              //       </div>
                              //     </div>
                              //   </div>
                              // </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-4">
                          Data not found
                        </div>
                      )}



                    </div> :
                    <div
                      className="d-flex flex-column justify-content-center align-items-center text-center rounded shadow-lg p-4 mt-4"
                      style={{
                        minHeight: "60vh",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      <img

                        src={`${APP_URL}/assets/img/NodataLight.png`}
                        alt="No data"
                        style={{
                          width: "150px",
                          marginBottom: "20px",
                          opacity: 0.8,
                        }}
                      />
                      <h5 className="text-muted">
                        Multibagger Recommendations will be displayed here.
                      </h5>
                    </div>
                  }




                  {/* close */}
                  <div class="d-flex align-items-baseline mt-3">
                    <h5 class="mb-1 fw-bold">Closed Recommendations</h5>
                    <small class="text-muted ms-2">
                      ({closedCount} {closedCount > 1 ? "Stocks" : "Stock"})
                    </small>
                  </div>
                  {userMultibaggerList?.dataList.length > 0 ?
                    <div>

                      <div
                        className={`p-3 rounded-3 d-none d-md-block ${theme === "dark" ? "text-light" : "bg-white text-dark"
                          }`}
                        style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                      >
                        <div className="row g-3 small">
                          <div className="col-md-1">Scrip</div>
                          <div className="col-md-1 text-end"></div>
                          <div className="col-md-1 text-end">Qty</div>
                          <div className="col-md-2 text-end">Recomm. Date</div>
                          <div className="col-md-2 text-end">Recomm. Price</div>
                          <div className="col-md-2 text-end">Exit Price</div>
                          <div className="col-md-2 text-end">Exit Date</div>
                          <div className="col-md-1 text-end">Book P&L</div>
                        </div>
                      </div>

                      {userMultibaggerList?.dataList?.length > 0 && userMultibaggerList.dataList.some(item => item.bookedAt !== null) ? (
                        userMultibaggerList.dataList.filter((item) => item.bookedAt !== null).map((stock, idx) => (
                          <div
                            key={idx}
                            className={`p-3 rounded-3 my-2 ${theme === "dark" ? "text-light" : "bg-light text-dark"
                              }`}
                            style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                          >
                            <div className="row g-2 align-items-center">
                              {/* Scrip */}
                              <div className="col-md-1 col-6">
                                <div className="d-flex align-items-center gap-2">
                                  <i
                                    className="fa fa-circle"
                                    style={{
                                      color: symbolColors[stock.symbol],
                                      fontSize: "10px",
                                    }}
                                  ></i>
                                  <span
                                    className={
                                      isChartLabelBlurred
                                        ? "portfolio-sensitive-label-blurred"
                                        : ""
                                    }
                                  >
                                    {stock.symbol}
                                  </span>
                                </div>
                              </div>
                              {/* View Report */}
                              <div className="col-md-1 col-6">
                                <div className="text-end" style={{ cursor: "pointer" }}>
                                  <i
                                    className="fa fa-file text-primary me-2 ms-2"
                                    style={{ fontSize: "12px" }}
                                  ></i>

                                  <span
                                    className="text-primary uni-cursor-pointer small"
                                    onClick={() => setSelectedStockId(stock.id)}
                                  >
                                    <small><small>View Report</small> </small>
                                  </span>
                                </div>
                              </div>
                              {/* Qty */}
                              <div className="col-md-1 col-6">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small className="d-block d-md-none text-muted">
                                      Qty
                                    </small>
                                  </small>
                                  <span>{stock.qty}</span>
                                </div>
                              </div>
                              {/* Recomm Date */}
                              <div className="col-md-2 col-6">
                                <div class="text-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      Recomm. Date{" "}
                                    </small>
                                  </small>
                                  <span>{moment(stock.recomandedDate).format("D MMM YYYY")}</span>
                                </div>
                              </div>
                              {/* Avg price */}
                              <div className="col-md-2 col-6">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      Recomm. Price{" "}
                                    </small>
                                  </small>
                                  <span>{stock.recomPrice?.toFixed(2)}</span>
                                </div>
                              </div>
                              {/* Exit Price */}
                              <div className="col-md-2 col-6">
                                <div class="text-end">
                                  <small>
                                    <small className="d-block d-md-none text-muted">
                                      Exit Price
                                    </small>
                                  </small>
                                  <span>{stock.exitPrice?.toFixed(2)}</span>
                                </div>
                              </div>
                              {/* Exit Date */}
                              <div className="col-md-2 col-6">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      Exit Date{" "}
                                    </small>
                                  </small>
                                  <span>
                                    {moment(stock.exitDate).format(
                                      "DD MMM YYYY",
                                    )}
                                  </span>
                                </div>
                              </div>
                              {/* P&L */}
                              <div className="col-md-1 col-6">
                                <div class="text-end">
                                  <small>
                                    <small className="d-block d-md-none text-muted">
                                      Book P&L
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.overallPLVal >= 0
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.overallPLVal?.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                    })}
                                    <br />
                                    <small>
                                      ({stock.overallPLPer?.toFixed(2)}%)
                                      <i
                                        className={`fa fa-caret-${stock.overallPLPer >= 0 ? "up" : "down"}`}
                                      ></i>
                                    </small>
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Modal */}
                            {selectedStockId === stock.id && (
                              <div className="modal fade show d-block" tabIndex="-1">
                                <div className="modal-dialog modal-xl modal-dialog-centered">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">{stock.symbol} Report</h5>
                                      <button
                                        className="btn-close"
                                        onClick={() => setSelectedStockId(null)}
                                      ></button>
                                    </div>
                                    <div className="modal-body" style={{ height: "80vh" }}>
                                      <iframe
                                        src={`${stock.multibaggerReportPath}#toolbar=0`}
                                        style={{ width: "100%", height: "100%", border: 0 }}
                                        title={stock.symbol}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-4">
                          Data not found
                        </div>
                      )}
                    </div> :
                    <div
                      className="d-flex flex-column justify-content-center align-items-center text-center rounded shadow-lg p-4 mt-4"
                      style={{
                        minHeight: "60vh",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      <img

                        src={`${APP_URL}/assets/img/NodataLight.png`}
                        alt="No data"
                        style={{
                          width: "150px",
                          marginBottom: "20px",
                          opacity: 0.8,
                        }}
                      />
                      <h5 className="text-muted">
                        Multibagger Recommendations will be displayed here.
                      </h5>
                    </div>
                  }
                </div>
              </div>
            </section>
            {/* : <MultibaggerModal />} */}
          </>
          :
          <>
            <section>
              <div className="container py-3">
                <div className="row justify-content-center d-none">
                  <div className="col-md-5">
                    <div className="border rounded-3 text-center p-3">
                      <h3 className="fw-bold">Multibagger Porfolio Setup</h3>
                      <p>Enter investment amount for each multibagger</p>
                      <div class="form-floating mx-md-5">
                        <input
                          type="text"
                          class="form-control fw-bold"
                          id="floatingInput"
                          placeholder="1005000"
                          style={{ "font-size": "1.5rem; letter-spacing: 1px" }}
                          value={amounts.portfolioAmt}
                          onChange={handleAmountChange("portfolioAmt")}
                        />
                        <label for="floatingInput">Enter Investment Amount</label>
                        {validationErrors.portfolioAmt && (
                          <div className="text-danger mt-1">
                            {validationErrors.portfolioAmt}
                          </div>
                        )}
                      </div>
                      <small class="d-block fst-italic my-2">
                        {numberToWords(amounts.portfolioAmt.replace(/,/g, ''))}
                      </small>
                      <button className="btn btn-dark rounded-3" onClick={() => handleMultibaggerAllocation()} > Add Funds Now</button>
                    </div>
                  </div>

                </div>
                <div class="row g-3 mb-3">
                  <div class="col-md-12">
                    <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                  </div>
                  <div class="border rounded-3 p-3">
                    <div class="row g-3 mb-3">
                      <div class="col-md-12">
                        <h1 class="fs-4 fw-bold ">Multibagger Portfolio Setup</h1>
                        <p>Let's get started by setting up your multibagger portfolio. Please enter the amount you'd like to allocate to each multibagger stock.</p>
                        <div class="my-3">
                          <div class="form-floating d-inline-block">
                            <input
                              type="text"
                              class="form-control fw-bold"
                              id="floatingInput"
                              placeholder="1005000"
                              style={{ "font-size": "1.5rem; letter-spacing: 1px" }}
                              value={amounts.portfolioAmt}
                              onChange={handleAmountChange("portfolioAmt")}
                            />
                            <label for="floatingInput">Enter Investment Amount</label>
                            {validationErrors.portfolioAmt && (
                              <div className="text-danger mt-1">
                                {validationErrors.portfolioAmt}
                              </div>
                            )}
                          </div>
                          <small class="d-block fst-italic text-muted mt-2">{numberToWords(amounts.portfolioAmt.replace(/,/g, ''))}</small>
                        </div>
                        <button class="btn btn-dark" onClick={() => handleMultibaggerAllocation()}>Continue</button>
                        <p class="text-muted mt-3 mb-0"><small><b>Note:</b> This is not an actual fund transfer. The amount is used only to create a personalized dashboard for you.</small></p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </section>
          </>
        }

      </div>
    </Layout>
  );
}
